// Sentry initialization should be imported first!
import "sentry/instrument";

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "react-medium-image-zoom/dist/styles.css";
import { registerSW } from "virtual:pwa-register";
import MyErrorBoundary from "components/errorBoundry/MyErrorBoundary.jsx";

const updateSW = registerSW({
  onOfflineReady() { },
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.Fragment>
    <MyErrorBoundary>
      <App />
    </MyErrorBoundary>
  </React.Fragment>
);
